export const actionTypes = {
  SET_STOREDVALUE: "SET_STOREDVALUE",
  SET_LOADING: "SET_LOADING",
};
